module.exports = __webpack_public_path__ + "media/images/flags/MG-8953efc6c20c92308cc96570941be7a6.svg";